import { render, staticRenderFns } from "./dictcheck-item.vue?vue&type=template&id=3c21beee&scoped=true"
import script from "./dictcheck-item.vue?vue&type=script&lang=js"
export * from "./dictcheck-item.vue?vue&type=script&lang=js"
import style0 from "./dictcheck-item.vue?vue&type=style&index=0&id=3c21beee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c21beee",
  null
  
)

export default component.exports